export const GENERIC_ERROR = 'System Error. Please contact IT Support.'
